<script setup lang="ts">

</script>

<template>
  <div class="flex-1 w-full h-full bg-transparent px-4 pt-6 flex flex-col">
    <slot />
  </div>
</template>

<style scoped>

</style>